import React, { useCallback } from 'react'
import { TextField } from '@mui/material'
import { RegisterOptions, useController } from 'react-hook-form'

export const InputField = ({
  name,
  title,
  readOnly,
  rules,
  type,
  multiline,
  rows,
  disabled
}: {
  name: string
  title: string
  readOnly?: boolean
  rules?: RegisterOptions
  type?: string
  multiline?: boolean
  rows?: number
  disabled?: boolean
}) => {
  const { field, fieldState } = useController({ name, rules })

  const handleOnBlur = useCallback(
    (event: React.FocusEvent<HTMLInputElement>) => {
      if (type !== 'password') {
        const trimmed = event.target.value.trim()
        if (trimmed !== event.target.value) {
          field.onChange(trimmed)
        }
      }
    },
    [field, type]
  )

  return (
    <TextField
      onBlur={handleOnBlur}
      InputProps={{ readOnly: readOnly }}
      label={title}
      placeholder={title}
      error={!!fieldState.error}
      helperText={fieldState.error?.message}
      value={field.value}
      onChange={field.onChange}
      multiline={multiline}
      rows={rows || 1}
      type={type}
      data-cy={`contactus-form-${field.name}`}
      sx={{ input: { color: readOnly ? '#888' : undefined } }}
      disabled={disabled}
    />
  )
}
